import { Group, UserInfo } from '@/types';

export const hasEditPermission = (
  group: Group,
  userInfo: UserInfo | undefined,
) => {
  if (!userInfo) return false;
  return (
    userInfo.role === 'admin' ||
    (userInfo.role === 'group_admin' && group.is_member)
  );
};

export const hasMemberPermission = (
  group: Group,
  userInfo: UserInfo | undefined,
) => {
  if (!userInfo) return false;
  return userInfo?.role === 'admin' || group.is_member;
};

export const isGroupAdmin = (role: string) => {
  return ['admin', 'group_admin'].includes(role);
};

export const getTabs = (
  group: Group,
  userInfo: UserInfo, // eslint-disable-line @typescript-eslint/no-unused-vars
  commentId: number | undefined = undefined,
): {
  name: string;
  linkTo: { name: string; params: Record<string, unknown> };
}[] => {
  if (!group.id) {
    return [];
  }

  return [
    {
      name: 'アクティビティ',
      linkTo: { name: 'groupActivity', params: { groupId: group.id } },
    },
    commentId
      ? {
          name: 'コメント',
          linkTo: { name: 'groupComment', params: { commentId } },
        }
      : {
          name: 'コメント',
          linkTo: { name: 'groupDetail', params: { groupId: group.id } },
        },
    {
      name: 'グループマーク',
      linkTo: { name: 'groupMarks', params: { groupId: group.id } },
    },
    {
      name: 'メンバー',
      linkTo: { name: 'groupMembers', params: { groupId: group.id } },
    },
    {
      name: 'グループタグ',
      linkTo: { name: 'groupTagList', params: { groupId: group.id } },
    },
  ];
};
